module.exports = __webpack_public_path__ + "img/product-info.db904f82.png";